// @ is an alias to /src
import Loading from "@/components/Loading.vue";
import { Carousel, Slide } from "vue-carousel";
import { Donuz } from "@/donuz-js/Donuz";
import VuejsPaginate from "vuejs-paginate";

export default {
  name: "home",
  components: {
    Carousel,
    Slide,
    VuejsPaginate: "paginate",
    Loading
  },
  data() {
    return {
      response: {},
      prizes: [],
      banners:[],
      bannersMobile:[],
      categories: [],
      pagination: 0,
      actualCateg: {},
      prizesLoading: true,
      hide: false,
      page: 1,
    };
  },
  async created() {

    this.ESTABELECIMENTO.banners.forEach( e => {
      e.descricao.toLowerCase().includes('banner-mobile') 
        ? this.bannersMobile.push(e) : this.banners.push(e);
    })       
    
    this.response = await Donuz.category.getCategories(this.ESTABELECIMENTO.id);

    if (this.response.status == 200) {
      this.response.categorias.sort((a, b) => {
        if (a.categoria.toLowerCase() > b.categoria.toLowerCase()) {
          return 1;
        }
        return -1;
      });

      this.categories = this.response.categorias;

      for (let i = 0; i < this.categories.length; i++) {
        this.response = await Donuz.category.getSubCategories(this.categories[i].id, this.ESTABELECIMENTO.id);
        if (this.response.status == 200) {
          this.categories[i].subCategories = this.response.categorias;
        }
      }
    }

    this.categories.forEach(el => {
      if (el.subCategories) {
        el.subCategories.sort((c, d) => {
          if (c.categoria.toLowerCase() > d.categoria.toLowerCase()) {
            return 1;
          }
          return -1;
        })
      }
    });

    this.response = await Donuz.prizes.getRewards(this.ESTABELECIMENTO.id,
      this.ESTABELECIMENTO.ordem_exibicao,
      this.ESTABELECIMENTO.premios_por_pagina
    );

    this.pagination = parseInt(this.response.registros / this.ESTABELECIMENTO.premios_por_pagina);
    if (this.response.registros % this.ESTABELECIMENTO.premios_por_pagina != 0) {
      this.pagination++;
    }

    if (this.response.status == 200) {
      this.prizes = this.response.premios;
      this.prizesLoading = false;
    }
  },
  updated() {
    M.Collapsible.init(document.querySelectorAll('.collapsible'));
  },
  computed:{
    innerWidth(){
      return window.innerWidth;
    }
  },
  methods: {
    dropdown: function () {
      this.hide = !this.hide;
    },
    paginate: async function (page) {

      this.prizesLoading = true;
      let per_page = this.ESTABELECIMENTO.premios_por_pagina;

      if (this.actualCateg.id) {
        this.response = await Donuz.prizes.getRewardByCategory(this.actualCateg.id, this.ESTABELECIMENTO.id, this.actualCateg.subCateg, null, null, (page - 1) * per_page + "," + per_page)
        if (this.response.status == 200) {
          this.prizes = this.response.premios;
          this.prizesLoading = false;
        }
        else {
          this.prizes = [];
          this.prizesLoading = false;
        }
      } else {
        this.response = await Donuz.prizes.getRewards(this.ESTABELECIMENTO.id,
          this.ESTABELECIMENTO.ordem_exibicao,
          (page - 1) * per_page + "," + per_page
        );
        if (this.response.status == 200) {
          this.prizes = this.response.premios;
          this.prizesLoading = false;
        }
      }
    },

    getPrizesByCateg: async function (categ, subCateg = null) {
      if (subCateg == null) {
        if (categ.subCategories) {
          return;
        }
      }

      var id = categ.id;
      this.page = 1;
      this.actualCateg.id = id;
      this.actualCateg.subCateg = subCateg;


      this.prizesLoading = true;

      this.response = await Donuz.prizes.getRewardByCategory(id, this.ESTABELECIMENTO.id, subCateg, null, null, this.ESTABELECIMENTO.premios_por_pagina);
      if (this.response.status == 200) {
        this.prizes = this.response.premios;
      } else {
        this.prizes = [];
      }
      this.pagination = parseInt(this.response.registros / this.ESTABELECIMENTO.premios_por_pagina);
      if (this.response.registros % this.ESTABELECIMENTO.premios_por_pagina != 0) {
        this.pagination++;
      }

      this.prizesLoading = false;
    }
  }
};